import React from 'react';

const Processing = () => {
  return <>ManageOrder - Processing Screen</>;
};

export default Processing;
